import { render, staticRenderFns } from "./ExpendableCell.vue?vue&type=template&id=0ad80b98&scoped=true"
import script from "./ExpendableCell.vue?vue&type=script&lang=ts"
export * from "./ExpendableCell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad80b98",
  null
  
)

export default component.exports